import { render, staticRenderFns } from "./PromotionLimit.vue?vue&type=template&id=551c484d"
import script from "./PromotionLimit.vue?vue&type=script&lang=js"
export * from "./PromotionLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports